import { TimeSpan } from '@sparkware/app-utils';
import { ServiceBase } from '../ServiceBase';
import {IRegulation, IRegulationService} from './regulation.service.interface';
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {LegacyRegulationWrapper} from "./legacy-regulation-wrapper";
import {NullableString} from "../../../common/types/nullable-types";

export class RegulationService extends ServiceBase implements IRegulationService {
    constructor(services: IServiceFactoryExtended) {
        super(services);

        this.reaction(() => this.services.user.isAuthorized,
            () => {
                this.current = new LegacyRegulationWrapper(this.services.sdk.currentRegulation, this.getRegulationCode(), this.services);
            }, {
                fireImmediately: true
            });

    }
    getRegulationCode(): number {
        return this.services.sdk.getRegulationService().getRegulationCode();
    }

    isUSRegulation(): boolean {
        return this.services.sdk.getRegulationService().isUSRegulation();
    }

    get forceDemoButton(): boolean {
        return this.services.sdk.getRegulationService().forceDemoButton();
    }

    getSessionCooldownConfig(): { featureEnabled: boolean; cooldownTime: TimeSpan } {

        const sessionCooldownConfig = this.services.sdk.getRegulationService().getSessionCooldownConfig();

        return {
            ...sessionCooldownConfig,
            cooldownTime: TimeSpan.parse(sessionCooldownConfig.cooldownTime)
        };
    }

    current: IRegulation;


    shouldShowPlayerLimitsToaster(): boolean {
        return this.services.sdk.getRegulationService().shouldShowPlayerLimitsToaster();
    }

    shouldReplaceLoginWithDownloadAppForMobileWebApp(): boolean {
        return this.services.sdk.getSkin().shouldReplaceLoginWithDownloadAppForMobileWebApp();
    }

    shouldPreventOpenGameForMobileWebApp(): boolean {
        return this.services.sdk.getSkin().shouldPreventOpenGameForMobileWebApp();
    }

    getErrorMessage(errorCode: number): NullableString {
        return this.services.sdk.getRegulationService().getErrorMessage(errorCode);
    }
}
